import React from "react";
var __jsx = React.createElement;
// Warning! Order is important
import "./styles/variables.css";
import "./styles/reset.css";
import "./styles/helpers.css";
import "./styles/globals.css";
import "./styles/common.css";
import "./styles/AB_TEST.css";
import "./styles/TEMP.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { oldUserIdPropertyEvent } from "./utils/dataLayerEvents";
import { parseJsonSafely } from "./utils/GlobalJavascriptFunction";
import { unbxdAnalytics } from "./redux/actions/unbxdActions";
import { SELECTED_ENV, serverUrl } from "@globalConfig";
import useSentry from "./common/hooks/useSentry";
import { page404 as Page404 } from "./routes/asyncPages";
import { useFirstRenderHistoryLogic } from "@hooks/useFirstRender";
import useHashToLocalStoreEvent from "@hooks/useHashToLocalStoreEvent";
import { useSetReferral } from "@hooks/useGetReferral";
import toast, { Toaster } from "react-hot-toast";
import ConfirmPopup from "@componentsShared/ConfirmPopup/ConfirmPopup";
import { usePostHog } from "posthog-js/react";
import useScrollToTop from "@hooks/useScrollToTop";
import useInitDataLayerConfig from "@hooks/useInitDataLayerMeta";
import useIsWebView from "@hooks/useIsWebview";
import useIsIOS from "@hooks/useIsIOS";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import { SIGN_UP_URL } from "@/_MiniApps/auth/constants";
import useHelpers from "@hooks/useHelpers";
import useKeyboardDetector from "@hooks/useKeyboardDetector";
import { useMaintainSearchResultsDataStorage } from "@/pages/search/searchHooks/usePreserveData";
import { VideoRenderer } from "./_MiniApps/VideoRenderer/VideoRenderer";
import { useLocalStorageEventConsumer } from "@hooks/useLocalStorageEventConsumer";
import useCookieClient from "@hooks/useCookieClient";
import { Toast as SonnerToast } from "@syarahtech/ui";
import useDirection from "@hooks/useDirection";
if (__IS_CSR__ && __IS_PROD_ENV__ || SELECTED_ENV === "preprod") {
  console.log = function no_console() {};
}
var App = function App(_ref) {
  var routes = _ref.routes;
  useFirstRenderHistoryLogic();
  useMaintainSearchResultsDataStorage(["cardetail", "car-compare", "autos", "years", "filters"]);
  useKeyboardDetector("keyboardOpen");
  useSentry();
  useSetReferral();
  useScrollToTop();
  useLocalStorageEventConsumer();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    getCurrentUrl = _useHelpers.getCurrentUrl;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var location = useLocation();
  var urlParams = new URLSearchParams(location.search);
  var _useState = useState(parseJsonSafely(urlParams.get("user"))),
    userData = _useState[0],
    setUserData = _useState[1];
  var _useAuthActions = useAuthActions(),
    setUserDataContext = _useAuthActions.setUserData;
  var isWebView = useIsWebView();
  var isIos = useIsIOS();
  useInitDataLayerConfig({
    isWebView: isWebView,
    isIos: isIos
  });
  useEffect(function () {
    if (!isLoggedIn) return;
    oldUserIdPropertyEvent(user.phone_hashed, "window_load");
  }, []);
  var direction = useDirection();
  useHashToLocalStoreEvent();
  useEffect(function () {
    // get user data from url with token and set them into localstorage & cookies
    // try to parse user json in case it exists on query string & is valid json
    if (userData && userData.id && userData.token) {
      setUserDataContext(userData);
    }
  }, [userData === null || userData === void 0 ? void 0 : userData.token, userData === null || userData === void 0 ? void 0 : userData.id]);
  var posthog = usePostHog();
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  useEffect(function () {
    setUserData(null);
    var uuid = getCookieClient("UUID") || null;
    if (isLoggedIn) {
      var _user$id;
      posthog === null || posthog === void 0 ? void 0 : posthog.identify(user === null || user === void 0 ? void 0 : (_user$id = user.id) === null || _user$id === void 0 ? void 0 : _user$id.toString(), {
        uuid: uuid,
        phone_number: user.phone_number
      });
    } else if (uuid) {
      posthog === null || posthog === void 0 ? void 0 : posthog.identify(uuid, {
        uuid: uuid
      });
    }
  }, [isLoggedIn]);
  useEffect(function () {
    window.toast = toast;
    unbxdAnalytics({
      url: serverUrl + location.pathname + location.search,
      action: "visitor"
    });
  }, []);
  if (userData) {
    return null;
  }
  return routes ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VideoRenderer, null), /*#__PURE__*/React.createElement(ConfirmPopup, null), /*#__PURE__*/React.createElement(Toaster, {
    position: "bottom-center",
    toastOptions: {
      style: {
        // show on top of all elements
        zIndex: 99999,
        border: "1px solid #713200",
        padding: "16px",
        color: "#713200"
      }
    }
  }), /*#__PURE__*/React.createElement(SonnerToast, {
    toastOptions: {
      duration: 5000,
      closeButton: false
    },
    dir: direction
  }), /*#__PURE__*/React.createElement(Routes, null, routes.map(function (route, index) {
    var Element = route.component;
    var ResolvedElement = route.shouldAuth && !isLoggedIn ? function () {
      return /*#__PURE__*/React.createElement(Navigate, {
        to: createUrl(SIGN_UP_URL, {
          returnTo: getCurrentUrl(),
          referralLocation: route.login_event_tracking__IS_IT_NEEDED
        })
      });
    } : Element;
    return /*#__PURE__*/React.createElement(Route, {
      key: index,
      path: route.path,
      exact: route.exact,
      element: /*#__PURE__*/React.createElement(ResolvedElement, null)
    });
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(Page404, null)
  }))) : null;
};
export default App;